export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-cloud-abea8ee83858d44b30b5fa3bdd3a0de0.svg";